// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"148":"727973242bb33abd","1893":"727973242bb33abd"}[chunkId] + ".css";
};